import ConfirmPopover from '@/components/common/ConfirmPopover';
import IconButton from '@/components/common/IconButton';
import { Semaphore } from '@/types/semaphores';
import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import { Box, ListItem, ListItemText } from '@mui/material';
import { FC, useState } from 'react';
import SemaphoreListItemEdit from './SemaphoreListItemEdit';

type SemaphoreListItemProps = {
  semaphore: Semaphore;
  onSave?: (newSemaphore: Semaphore) => void;
  onDelete?: () => void;
};

const SemaphoreListItem: FC<SemaphoreListItemProps> = (props) => {
  const [openEdit, setOpenEdit] = useState(props.semaphore && !props.semaphore.name);
  return (
    <ListItem sx={{ gap: 1, pt: 0, pb: 0 }}>
      {openEdit ? (
        <SemaphoreListItemEdit
          semaphore={props.semaphore}
          onClose={(isEmpty) => {
            setOpenEdit(false);
            if (isEmpty) {
              props.onDelete && props.onDelete();
            }
          }}
          onSave={(newSemaphore) => {
            props.onSave && props.onSave(newSemaphore);
          }}
        />
      ) : (
        <>
          <ListItemText primary={props.semaphore.name} />
          <code>{props.semaphore.value}</code>
          <Box>
            <IconButton
              tooltip='Edit'
              onClick={() => {
                setOpenEdit(true);
              }}
            >
              <EditIcon />
            </IconButton>
            <ConfirmPopover
              text={
                <>
                  Delete <code>{props.semaphore.name}</code>?
                </>
              }
              onConfirm={() => props.onDelete && props.onDelete()}
              skipConfirm={!props.semaphore.name}
              icon={<ClearIcon />}
            />
          </Box>
        </>
      )}
    </ListItem>
  );
};

export default SemaphoreListItem;
